import { css } from 'emotion'

export const DeleteTaskButtonStyles = css``
